module.exports = __webpack_public_path__ + "img/marker_two_blue3.02dc5601.png";